import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { Sidebar } from './Sidebar'

const SIDEBAR_COLLAPSED_KEY = 'sidebar-collapsed'

export function DashboardLayout() {
  // Initialize from localStorage to prevent layout shift
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const stored = localStorage.getItem(SIDEBAR_COLLAPSED_KEY)
    return stored === 'true'
  })

  return (
    <div className="min-h-screen bg-background">
      {/* Sidebar */}
      <Sidebar onCollapsedChange={setSidebarCollapsed} />

      {/* Main content */}
      <main
        className={cn(
          'min-h-screen transition-all duration-300 p-8',
          sidebarCollapsed ? 'ml-16' : 'ml-60'
        )}
      >
        <Outlet />
      </main>
    </div>
  )
}
